import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_INSTALLATION_DOORS,
  GET_INSTALLATION_DOORS_SUCCESS,
  GET_INSTALLATION_DOORS_ERROR,
  ADD_INSTALLATION_DOOR,
  ADD_INSTALLATION_DOOR_SUCCESS,
  ADD_INSTALLATION_DOOR_ERROR,
  DELETE_INSTALLATION_DOOR,
  DELETE_INSTALLATION_DOOR_SUCCESS,
  DELETE_INSTALLATION_DOOR_ERROR,
  GET_INSTALLATION_DOOR,
  GET_INSTALLATION_DOOR_SUCCESS,
  GET_INSTALLATION_DOOR_ERROR,
  UPDATE_INSTALLATION_DOOR,
  UPDATE_INSTALLATION_DOOR_SUCCESS,
  UPDATE_INSTALLATION_DOOR_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/door';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.installationDoor;
const installationDoor = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullInstallation' || action.target === 'currentInstallation') {
        return {
          ...state,
          list: { ...initialSettings.list },
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'addInstallationDoor':
          key = 'add';
          break;
        case 'updateInstallationDoor':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST DOORS
    case GET_INSTALLATION_DOORS:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: null,
        },
      };
    case GET_INSTALLATION_DOORS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case GET_INSTALLATION_DOORS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserialize(action.data.data),
          loading: false,
        },
      };
    // ADD DOOR
    case ADD_INSTALLATION_DOOR:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case ADD_INSTALLATION_DOOR_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_INSTALLATION_DOOR_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // DELETE DOOR
    case DELETE_INSTALLATION_DOOR:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case DELETE_INSTALLATION_DOOR_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_INSTALLATION_DOOR_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // GET
    case GET_INSTALLATION_DOOR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_INSTALLATION_DOOR_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_DOOR_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // UPDATE
    case UPDATE_INSTALLATION_DOOR:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case UPDATE_INSTALLATION_DOOR_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_INSTALLATION_DOOR_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    default:
      return state;
  }
};

export default installationDoor;



// WEBPACK FOOTER //
// ./reducers/installation/installationDoor.js